import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import PatientInformation from "./work-order-details/patient-information"
import FacilityInformation from "./work-order-details/facility-information"
import ClientInformation from "./work-order-details/client-information"
import CaseInformation from "./work-order-details/case-information"
import Notes from "./work-order-details/notes";
import CreateWorkOrder from "./work-order-details/create-work-order";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../helpers/catch-error';
import { io } from "socket.io-client"; 




const WorkOrderAdd = () => {
    const navigate = useNavigate();
    const params = useParams()

    const [workOrderData, setWorkOrderData] = useState(null);
    const [workOrderChanges, setWorkOrderChanges] = useState(null);
    const [patientLoader, setPatientLoader] = useState(true);
    const [facilityLoader, setFacilityLoader] = useState(true);
    const [clientLoader, setClientLoader] = useState(true);
    const [caseLoader, setCaseLoader] = useState(true);
    const [isBtn, setIsBtn] = useState(false);
    const [prevNext, setPrevNext] = useState({ prev_id: null, next_id: null });
    const socketRef = useRef(null); 


    // Real-time Work Order Locking Logic
    useEffect(() => {
    const workOrderId = params.work_order_id;
    if (!workOrderId || workOrderId <= 0) return;

    // Get current user's name from localStorage
    const firstName = localStorage.getItem("@first_name") || "";
    const lastName = localStorage.getItem("@last_name") || "";
    const currentAdminName = `${firstName} ${lastName}`.trim() || "Admin User";


    const backendUrl = process.env.REACT_APP_WEB_SERVICES_URL ;

socketRef.current = io(backendUrl, {
    path: "/socket.io/", 
    transports: ["websocket", "polling"], 
    withCredentials: true
});



    
    // Request lock for this work order with actual Admin Name
    socketRef.current.emit("join_work_order", {
        workOrderId: workOrderId,
        adminName: currentAdminName,
    });

    // Listen if work order is already locked by another admin
    socketRef.current.on("work_order_locked", (data) => {
        Swal.fire({
            icon: "warning",
            title: "Work Order Locked",
            text: `This work order is currently open by ${data.lockedBy || 'another admin'}. You cannot view/edit it right now.`,
            allowOutsideClick: false,
            confirmButtonText: "Go Back",
            backdrop: `rgba(0, 0, 0, 0.8)`
        }).then(() => {
            navigate('/'); // Automatically redirect back
        });
    });

    // Cleanup: Release lock on unmount/navigation
    return () => {
        if (socketRef.current) {
            socketRef.current.emit("leave_work_order");
            socketRef.current.disconnect();
        }
    };
}, [params.work_order_id, navigate]);

    useEffect(() => {
        setWorkOrder();
    }, [params.work_order_id]); 


    useEffect(() => {

        let new_obj = { ...workOrderData }
        if (workOrderChanges) {
            Object.keys(workOrderChanges).forEach(function (key) {

                new_obj[key] = workOrderChanges[key];

            });
            setWorkOrderData(new_obj)
        }

    }, [workOrderChanges]);

    const saveWorkOrder = async (e) => {


        if (!workOrderData?.patient_id || !workOrderData?.facility_id || !workOrderData?.client_id) {

            Swal.fire({ icon: "error", title: "Work Order Info", text: "Please enter patient, facility and client information.." });

        } else {

            setIsBtn(true);
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/create-work-order", { work_order_id: workOrderData?.work_order_id }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setWorkOrderChanges({ status: 1, work_order_no: response?.data?.work_order_no });

                    // navigate("/admin/home")



                } else {

                    Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                catchError(error, navigate)
                setIsBtn(false);

            });

        }


    }

    const setWorkOrder = async () => {


        if (params.work_order_id && params.work_order_id > 0) {
            await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-work-order/" + params.work_order_id, {
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {

                        setWorkOrderData(response?.data?.work_order);
                        setPatientLoader(false);
                        setFacilityLoader(false);
                        setClientLoader(false);
                        setCaseLoader(false);
                        setPrevNext({
                            prev_id: response.data.prev_id,
                            next_id: response.data.next_id,
                        });

                    } else {

                        Swal.fire({ icon: "error", title: "Pending Admin Action Work Order Failed to Load", text: response?.data?.message });

                    }

                })
                .catch(function (error) {

                    if (error.status == 403 ) {
                        Swal.fire({ icon: "error", title: "Session Expired", text: error.message });
                        navigate("/login");
                    }
                    else {
                        Swal.fire({ icon: "error", title: "Pending Admin Action Work Order Failed", text: error.message });
                    }

                });
        }
        else {
            setPatientLoader(false);
            setFacilityLoader(false);
            setClientLoader(false);
            setCaseLoader(false);


        }
    }






    return (
        <div className="container-fluid  ">
 {workOrderData?.status > 0 &&
            <div className="row px-2 pt-4 ">
                <div className="col-6 ">
                    <label className="text-dark fw-bold fs-5 me-2" >WORK ORDER REQUEST  </label>
                </div>
                <div className="col text-end">
                    {/* 🔹 Prev / Next Buttons */}
                    {prevNext.prev_id && (
                        <Link
                            to={`/admin/work-order/${prevNext.prev_id}`}
                            className="btn btn-sm btn-primary me-2"
                        >
                            ◀ Prev
                        </Link>
                    )}
                    {prevNext.next_id && (
                        <Link
                            to={`/admin/work-order/${prevNext.next_id}`}
                            className="btn btn-sm btn-warning me-2"
                        >
                            Next ▶
                        </Link>
                    )}


                </div>

            </div>
}


            <div className="row px-2 py-3">

                <div className="col-6 ">
                    {workOrderData?.status > 0 ?
                        <label className="fw-bold fs-5" >CASE DATE: <span className="text-danger text-uppercase"> {workOrderData?.wo_creation_date_days > 14 ? workOrderData?.wo_creation_date_formatted + " (2 Weeks+)" : workOrderData?.wo_creation_date_formatted + " (" + workOrderData?.wo_creation_date_days + " days)"}</span></label>
                        :
                        <label className="text-dark fw-bold fs-5 me-2" >WORK ORDER REQUEST  </label>
                    }
                </div>

                <div className="col text-end">


                    {/* Existing Save / Status Buttons */}

                    {workOrderData?.status > 0 ?
                        <>
                            {(workOrderData && workOrderData?.follow_up_date && workOrderData?.follow_up_date !== "none") &&
                                <span className="patient-order"><label className="fw-bold fs-5" >FOLLOW-UP DATE: <span className="text-danger">{workOrderData.follow_up_date_f}</span> | </label> </span>
                            }
                            <span className="patient-order"><label className="fw-bold fs-5" >WORK ORDER #: <span className="text-danger">{workOrderData.work_order_no}</span></label> </span>
                        </>
                        :
                        <>
                            <button disabled={isBtn} onClick={() => { saveWorkOrder(); }} className="btn btn-primary " type="button"> {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : 'Save Work Order'}</button>
                        </>
                    }

                </div>

            </div>




            {/* BEGIN OPEN WORK ORDERS - PATIENT INFORMATION    */}

            <div className="row mb-b gx-3" >

                <div className="col-sm-6 mb-3" >
                    <PatientInformation
                        work_order={workOrderData}
                        is_loading={patientLoader}
                        onWorkOrderChange={(e) => {

                            setWorkOrderChanges(e);
                        }
                        }

                    />
                </div>
                <div className="col-sm-6 mb-3" >
                    <FacilityInformation
                        work_order={workOrderData}
                        is_loading={facilityLoader}
                        onWorkOrderChange={(e) => {
                            setWorkOrderChanges(e);
                        }
                        }




                    />
                </div>


            </div>

            {/* END OPEN WORK ORDERS - PATIENT INFORMATION */}


            {(workOrderData?.work_order_id > 0) &&
                <>
                    {/* BEGIN OPEN WORK ORDERS - FACILITY INFORMATION    */}

                    <div className="row  " >


                    </div>
                    <div className="row " >

                        <div className="col-md-12 my-3 " >
                            <ClientInformation
                                work_order={workOrderData}
                                is_loading={clientLoader}
                                onWorkOrderChange={(e) => {
                                    setWorkOrderChanges(e);
                                }
                                }




                            />
                        </div>

                    </div>
                    {/* END OPEN WORK ORDERS - CASE INFORMATION */}




                    <div className="row " >

                        <div className="col-md-12 my-3 " >
                            <CaseInformation
                                work_order={workOrderData}
                                is_loading={caseLoader}
                                onWorkOrderChange={(e) => {
                                    setWorkOrderChanges(e);
                                }
                                }




                            />
                        </div>

                    </div>


                    {(workOrderData?.status > 0 && workOrderData?.work_order_no) ?
                        <div className="row " >

                            <div className="col-md-12 my-3 " >
                                <Notes work_order={workOrderData}
                                    is_loading={clientLoader}
                                    onWorkOrderChange={(e) => {
                                        setWorkOrderChanges(e);
                                    }
                                    } />

                            </div>

                        </div>
                        :
                        <div className="row ">

                            <div className="col-md-12 my-3 " >

                                <CreateWorkOrder work_order={workOrderData}
                                    is_loading={clientLoader}
                                    onWorkOrderChange={(e) => {
                                        setWorkOrderChanges(e);
                                    }
                                    } />

                            </div>

                        </div>
                    }






                </>
            }
        </div>


    )
};

export default WorkOrderAdd;